import React, { useEffect, useState } from 'react';
// import Link from 'next/link';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import rootAction from '../../../stateManagment/actions/rootAction';
import { LOADER_DURATION } from '../../../helpers/Constants';
import MenuUserSection from "./MenuUserSection";

import Partner1Image from '../../resources/themeContent/images/partner1.png';
import Partner2Image from '../../resources/themeContent/images/partner2.png';
import { MakeApiCallSynchronous, MakeApiCallAsync } from '../../../helpers/ApiHelpers';
import Config from '../../../helpers/Config';
import { checkIfStringIsEmtpy, showInfoMsg } from '../../../helpers/ValidationHelper';
import LoginUserModal from '../modal/LoginUserModal';
import { makeAnyStringLengthShort, replaceWhiteSpacesWithDashSymbolInUrl } from '../../../helpers/ConversionHelper';
import { getLanguageCodeFromSession, GetLocalizationControlsJsonDataForScreen, replaceLoclizationLabel } from '../../../helpers/CommonHelper';
import GlobalEnums from '../../../helpers/GlobalEnums';

import Autocomplete from 'react-autocomplete'


const MegaMenu = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchForm, setSearchForm] = useState(false);
    const [collapsed, setCollapsed] = useState(true);
    const [SearchTerm, setSearchTerm] = useState("");
    const [CategoriesList, setCategoriesList] = useState([]);
    const [displayLoginUserModal, setDisplayLoginUserModal] = useState(false);
    const [adminPanelBaseURL, setBaseUrl] = useState(Config['ADMIN_BASE_URL']);
    const [LogoImageFromStorage, setLogoImageFromStorage] = useState(useSelector(state => state.commonReducer.websiteLogoInLocalStorage));
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);
    const [langCode, setLangCode] = useState('');
    const totalCartItems = useSelector(state => state.cartReducer.totalCartItems);

    const loginUserDataJson = useSelector(state => state.userReducer.user);
    const loginUser = JSON.parse(loginUserDataJson ?? "{}");

    const [value, setValue] = useState('');
    const [ProductName, setProductNameList] = useState([]);

    // --- Search bar UI state (for inline hover/focus styling) ---
    const [isFocused, setIsFocused] = useState(false);
    const [buttonHover, setButtonHover] = useState(false);
    const [clearHover, setClearHover] = useState(false);

    const handleCart = (event) => {
        event.preventDefault();

        if (totalCartItems != null && totalCartItems != null && totalCartItems > 0) {
            navigate('/' + getLanguageCodeFromSession() + '/cart');
        } else {
            showInfoMsg('No item exists in your cart');
        }

    }

    const handleSearchForm = () => {
        setSearchForm(!searchForm);

    }

    const handleOpenCloseLoginUserModal = (event) => {

        event.preventDefault();
        setDisplayLoginUserModal(!displayLoginUserModal);
    }


    const HandleLogout = (e) => {

        localStorage.setItem("user", JSON.stringify('{}'));
        dispatch(rootAction.userAction.setUser('{}'));

        navigate('/', { replace: true });
    }


    const submitSearchForm = () => {

        if (value != null && value != undefined && value.length > 1) {
            let url = "/" + getLanguageCodeFromSession() + "/all-products/0/all-categories?SearchTerm=" + value;
            setSearchForm(!searchForm);

            navigate(url, { replace: true });
            window.location.reload();
        }
    }


    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    }

    const navigateOnCategoryClick = (CategoryID, categoryName, e) => {

        CategoryID = CategoryID ?? 0;
        categoryName = categoryName ?? "all-categories"

        let newPageUrl = `/${getLanguageCodeFromSession()}/all-products/${CategoryID}/${replaceWhiteSpacesWithDashSymbolInUrl(categoryName)}`

        window.location.href = newPageUrl;

        // if (pathName.includes("AllProducts")) {
        //     window.location.href = newPageUrl;
        // } else {
        //     navigate(newPageUrl);
        // }

        //  navigate(newPageUrl);



        e.preventDefault();

    }

    useEffect(() => {
        let elementId = document.getElementById("navbar");
        document.addEventListener("scroll", () => {
            if (window.scrollY > 170) {
                elementId.classList.add("is-sticky");
            } else {
                elementId.classList.remove("is-sticky");
            }
        });
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {

        const getDataInUseEffect = async () => {


            //--Get language code
            let lnCode = getLanguageCodeFromSession();
            await setLangCode(lnCode);


            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',

            }


            const param = {
                requestParameters: {
                    PageNo: 1,
                    PageSize: 100,
                    recordValueJson: "[]",
                },
            };

            //--Get categories list
            const categoriesResponse = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_CATEGORIES_LIST'], null, param, headers, "POST", true);
            if (categoriesResponse != null && categoriesResponse.data != null) {
                await setCategoriesList(JSON.parse(categoriesResponse.data.data));
                console.log("Header Menu Categories List:");
                console.log(JSON.parse(categoriesResponse.data.data));
            }

            //--Get prodduct name list
            const productnameResponse = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_PRODUCTNAME_LIST'], null, param, headers, "POST", true);
            if (productnameResponse != null && productnameResponse.data != null) {
                await setProductNameList(JSON.parse(productnameResponse.data.data));
                console.log("Header product Name List:");
                console.log(JSON.parse(productnameResponse.data.data));
            }


            //--Get Website Logo
            if (!checkIfStringIsEmtpy(LogoImageFromStorage)) {

                let paramLogo = {
                    requestParameters: {
                        recordValueJson: "[]",
                    },
                };

                let WebsiteLogoInLocalStorage = "";
                let logoResponse = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_WEBSITE_LOGO'], null, paramLogo, headers, "POST", true);
                if (logoResponse != null && logoResponse.data != null) {
                    console.log(logoResponse.data)

                    if (logoResponse.data.data != "") {
                        let logoData = JSON.parse(logoResponse.data.data);
                        WebsiteLogoInLocalStorage = logoData[0].AppConfigValue;
                        dispatch(rootAction.commonAction.setWebsiteLogo(WebsiteLogoInLocalStorage));
                        setLogoImageFromStorage(WebsiteLogoInLocalStorage);
                    }


                }
            }

            //-- Get website localization data
            let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["MegaMenu"], null);
            if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
                await setLocalizationLabelsArray(arryRespLocalization);
            }
        }

        //--start loader
        dispatch(rootAction.commonAction.setLoading(true));

        // call the function
        getDataInUseEffect().catch(console.error);

        //--stop loader
        setTimeout(() => {
            dispatch(rootAction.commonAction.setLoading(false));
        }, LOADER_DURATION);
    }, [])


    const classOne = collapsed ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';
    const classTwo = collapsed ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right';



    return (

        <>
            <div className="navbar-area">
                <div id="navbar" className="comero-nav">
                    <div className="container">
                  
                        <nav className="navbar navbar-expand-md navbar-light">
                            <Link to={`/${getLanguageCodeFromSession()}/`} className="navbar-brand">
                                <img src={adminPanelBaseURL + LogoImageFromStorage} width={80} height={41} alt="logo" />
                            </Link>
                            
                            <button
                                onClick={toggleNavbar}
                                className={classTwo}
                                type="button"
                                data-toggle="collapse"
                                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                            >
                                <span className="icon-bar top-bar"></span>
                                <span className="icon-bar middle-bar"></span>
                                <span className="icon-bar bottom-bar"></span>
                            </button>

                            <div className={classOne} id="navbarSupportedContent">
                                <ul className="navbar-nav">

                                    <li className="nav-item p-relative">
                                        <Link to={`/${getLanguageCodeFromSession()}/`} className="nav-link active" id="lbl_mgmenu_home">
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "Home", "lbl_mgmenu_home")
                                                :
                                                "Home"
                                            }
                                        </Link>


                                    </li>

                                    <li className="nav-item p-relative">
                                        <Link to={`/${getLanguageCodeFromSession()}/all-products/0/all-categories`} className="nav-link active" id="lbl_mgmenu_products">
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "All Products", "lbl_mgmenu_products")
                                                :
                                                "Most Shopped"
                                            }
                                        </Link>


                                    </li>
                                    <li className="nav-item p-relative">
                                        <Link to={`/${getLanguageCodeFromSession()}/all-products/0/all-categories`} className="nav-link active" id="lbl_mgmenu_products">
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "All Products", "lbl_mgmenu_products")
                                                :
                                                "Top Deals"
                                            }
                                        </Link>


                                    </li>
                                    <li className="nav-item p-relative">
                                        <Link to={`/${getLanguageCodeFromSession()}/orders-history`} className="nav-link active" id="lbl_mgmenu_products">
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "My Enquiry", "lbl_mgmenu_products")
                                                :
                                                "My Enquiry"
                                            }
                                        </Link>


                                    </li>

                                </ul>
                            <div className="others-option">
                                    <div className="option-item">
                                        <i
                                            onClick={handleSearchForm}
                                            className="search-btn fas fa-search"
                                            style={{
                                                display: searchForm ? 'none' : 'none'
                                            }}
                                        ></i>

                                        <i
                                            onClick={handleSearchForm}
                                            className={`close-btn fas fa-times ${searchForm ? 'active' : ''}`}
                                        ></i>

                                      <div
                                           
                                            style={{
                                                display: searchForm ? 'block' : 'block'
                                            }}
                                        >
                                            <div style={styles.searchBoxModern}>
                                                <form
                                                    style={{
                                                        ...styles.searchFormModern,
                                                        ...(isFocused ? styles.searchFormModernFocused : {})
                                                    }}
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        submitSearchForm();
                                                    }}
                                                >
                                                    <i className="fas fa-search" style={styles.searchIconLeft}></i>

                                                    <Autocomplete
                                                        items={ProductName}
                                                        shouldItemRender={(item, value) =>
                                                            item.label.toLowerCase().includes(value.toLowerCase())
                                                        }
                                                        getItemValue={(item) => item.label}
                                                        renderMenu={(items, value, style) => (
                                                            <div style={{ ...style, ...styles.autocompleteMenuModern }}>
                                                                {value.length > 0 && items.length === 0 ? (
                                                                    <div style={styles.autocompleteEmpty}>No products found</div>
                                                                ) : items}
                                                            </div>
                                                        )}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div
                                                                key={item.id}
                                                                style={{
                                                                    ...styles.autocompleteItemModern,
                                                                    ...(isHighlighted ? styles.autocompleteItemHighlighted : {})
                                                                }}
                                                            >
                                                                <i className="fas fa-search" style={{
                                                                    ...styles.itemIcon,
                                                                    ...(isHighlighted ? styles.itemIconHighlighted : {})
                                                                }}></i>
                                                                <span>{item.label}</span>
                                                            </div>
                                                        )}
                                                        value={value}
                                                        onChange={(e) => {
                                                            setValue(e.target.value);
                                                            setSearchTerm(e.target.value);
                                                        }}
                                                        onSelect={(val) => {
                                                            setValue(val);
                                                            setSearchTerm(val);
                                                            submitSearchForm();
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                e.preventDefault();
                                                                submitSearchForm();
                                                            }
                                                            if (e.key === "Escape") {
                                                                setValue("");
                                                            }
                                                        }}
                                                        wrapperProps={{ style: styles.autocompleteWrapperModern }}
                                                        inputProps={{
                                                            style: styles.searchInputModern,
                                                            placeholder: "Select product...",
                                                            onFocus: () => setIsFocused(true),
                                                            onBlur: () => setIsFocused(false)
                                                        }}
                                                    />

                                                    {value?.length > 0 && (
                                                        <i
                                                            className="fas fa-times"
                                                            style={{
                                                                ...styles.searchClearBtn,
                                                                ...(clearHover ? styles.searchClearBtnHover : {})
                                                            }}
                                                            onMouseEnter={() => setClearHover(true)}
                                                            onMouseLeave={() => setClearHover(false)}
                                                            onClick={() => setValue("")}
                                                        ></i>
                                                    )}

                                                    <button
                                                        style={{
                                                            ...styles.searchButtonModern,
                                                            ...(buttonHover ? styles.searchButtonModernHover : {})
                                                        }}
                                                        onMouseEnter={() => setButtonHover(true)}
                                                        onMouseLeave={() => setButtonHover(false)}
                                                        type="submit"
                                                    >
                                                        <i className="fas fa-search"></i>
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                                            
                                    <div className="option-item">

                                        {
                                            loginUser != null && loginUser != undefined && loginUser.UserID != undefined && loginUser.UserID > 0
                                                ?
                                                <>
                                                    <Link to="#"
                                                        onClick={(e) => {
                                                            handleOpenCloseLoginUserModal(e);
                                                        }}
                                                    >
                                                        {loginUser.FirstName}

                                                    </Link>


                                                </>
                                                :
                                                <>
                                                    <Link to={`/${getLanguageCodeFromSession()}/login`} id="lbl_mgmenu_login">
                                                        {LocalizationLabelsArray.length > 0 ?
                                                            replaceLoclizationLabel(LocalizationLabelsArray, "Login", "lbl_mgmenu_login")
                                                            :
                                                            "Login"
                                                        }
                                                    </Link>
                                                </>
                                        }


                                    </div>

                                    {
                                        loginUser != null && loginUser != undefined && loginUser.UserID != undefined && loginUser.UserID > 0
                                            ?
                                            <>
                                                <div className="option-item">
                                                    <Link to="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            HandleLogout(e);
                                                        }}
                                                        id="lbl_mgmenu_logout"
                                                    >
                                                        {LocalizationLabelsArray.length > 0 ?
                                                            replaceLoclizationLabel(LocalizationLabelsArray, "Logout", "lbl_mgmenu_logout")
                                                            :
                                                            "Logout"
                                                        }
                                                    </Link>
                                                </div>


                                            </>
                                            :
                                            <>

                                            </>
                                    }

                                    <div className="option-item">
                                        <Link to="#"
                                            onClick={(e) => {
                                                handleCart(e)
                                            }}
                                        >


                                            <span id="lbl_mgmenu_cart">
                                                {LocalizationLabelsArray.length > 0 ?
                                                    replaceLoclizationLabel(LocalizationLabelsArray, "Cart", "lbl_mgmenu_cart")
                                                    :
                                                    "Cart"
                                                }
                                            </span>
                                            ({totalCartItems ?? 0}) <i className="fas fa-shopping-bag"></i>
                                        </Link>
                                    </div>

                                </div>
                               
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
            {
                loginUser != null && loginUser != undefined && loginUser.UserID != undefined && loginUser.UserID > 0 && displayLoginUserModal
                    ?
                    <LoginUserModal handleOpenCloseLoginUserModal={handleOpenCloseLoginUserModal} />
                    :
                    <>
                    </>
            }

        </>
    );

}

// --- Inline styles for the modern search bar ---
const styles = {
    searchBoxModern: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
    searchFormModern: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: '520px',
        background: '#fff',
        border: '1px solid #e6e6e6',
        borderRadius: '50px',
        padding: '4px 4px 4px 18px',
        transition: 'box-shadow 0.25s ease, border-color 0.25s ease',
    },
    searchFormModernFocused: {
        borderColor: '#ff6f61',
        boxShadow: '0 0 0 4px rgba(255, 111, 97, 0.12)',
    },
    searchIconLeft: {
        color: '#aaa',
        fontSize: '14px',
        marginRight: '10px',
    },
    autocompleteWrapperModern: {
        flex: 1,
        position: 'relative',
    },
    searchInputModern: {
        width: '100%',
        height: '42px',
        border: 'none',
        outline: 'none',
        fontSize: '14px',
        background: 'transparent',
        color: '#333',
    },
    searchClearBtn: {
        color: '#bbb',
        fontSize: '13px',
        cursor: 'pointer',
        padding: '0 10px',
        transition: 'color 0.2s ease',
    },
    searchClearBtnHover: {
        color: '#666',
    },
    searchButtonModern: {
        width: '40px',
        height: '40px',
        minWidth: '40px',
        borderRadius: '50%',
        border: 'none',
        background: '#ff6f61',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'background 0.2s ease, transform 0.15s ease',
    },
    searchButtonModernHover: {
        background: '#ff5647',
        transform: 'scale(1.05)',
    },
    autocompleteMenuModern: {
        position: 'absolute',
        top: 'calc(100% + 8px)',
        left: 0,
        right: 0,
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        overflow: 'hidden',
        zIndex: 50,
        maxHeight: '300px',
        overflowY: 'auto',
    },
    autocompleteItemModern: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 16px',
        fontSize: '14px',
        color: '#333',
        cursor: 'pointer',
        transition: 'background 0.15s ease',
    },
    autocompleteItemHighlighted: {
        background: '#fff2f1',
        color: '#ff6f61',
    },
    itemIcon: {
        fontSize: '11px',
        color: '#ccc',
    },
    itemIconHighlighted: {
        color: '#ff6f61',
    },
    autocompleteEmpty: {
        padding: '14px 16px',
        fontSize: '13px',
        color: '#999',
        textAlign: 'center',
    },
};

export default MegaMenu;